import script from "./MgCharacter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MgCharacter.vue?vue&type=script&setup=true&lang=ts"

import "./MgCharacter.vue?vue&type=style&index=0&id=41a23f47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a23f47"]])

export default __exports__